import React,{useState} from "react";
import { Button,Icon } from "@pmi/nyx-design-system";

// Recommendations Dropdown code
function Recommendations() {
    const [isCardOpen, setIsCardOpen] = useState(false);
    return (
        <>
            <Button variant="primary" onClick={() => setIsCardOpen(!isCardOpen)}>
                Recommendations <Icon className="mt-1" name={isCardOpen ? "chevron-up" : "chevron-down"} />
            </Button>
        </>
    )
}
export default Recommendations;